// src/app/core/mainPage/prompt/prompt-examples/components/GalleryPromptCard.tsx
import { ImageWithFallback } from "@/app/shared/ui";
import type { GalleryPromptCardProps } from "../types";

export function GalleryPromptCard({ example, onSelect }: GalleryPromptCardProps) {
  return (
    <button
      type="button"
      onClick={() => onSelect(example.prompt)}
      className="group relative w-full overflow-hidden rounded-2xl border border-border"
      style={{ breakInside: 'avoid' }} // <-- гарантирует, что карточка не разорвётся между колонками
    >
      <ImageWithFallback
        src={example.imageUrl}
        alt={example.prompt}
        className="w-full h-auto object-cover transition duration-300 group-hover:scale-105"
      />
      {example.prompt && (
        <>
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent" />
          <div className="absolute inset-x-0 bottom-0 p-2.5 text-left text-xs font-medium text-white leading-tight">
            {example.prompt}
          </div>
        </>
      )}
    </button>
  );
}